var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurityAndAutomationSdk = function SvgSecurityAndAutomationSdk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.429,
    clipPath: "url(#security-and-automation-sdk_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.286,
    height: 14.286,
    x: 39.286,
    y: 15,
    stroke: "#fff",
    rx: 0.714,
    transform: "rotate(180 39.286 15)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.143,
    cy: 7.857,
    r: 2.857,
    stroke: "#fff",
    transform: "rotate(180 32.143 7.857)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.286,
    height: 14.286,
    x: 0.714,
    y: 10.714,
    stroke: "url(#security-and-automation-sdk_svg__b)",
    rx: 0.714
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.857,
    cy: 17.857,
    r: 2.857,
    stroke: "url(#security-and-automation-sdk_svg__c)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.286,
    height: 14.286,
    x: 0.714,
    y: 25,
    stroke: "url(#security-and-automation-sdk_svg__d)",
    rx: 0.714
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.857,
    cy: 32.143,
    r: 2.857,
    stroke: "url(#security-and-automation-sdk_svg__e)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.286,
    height: 14.286,
    x: 15,
    y: 25,
    stroke: "url(#security-and-automation-sdk_svg__f)",
    rx: 0.714
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.143,
    cy: 32.143,
    r: 2.857,
    stroke: "url(#security-and-automation-sdk_svg__g)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "security-and-automation-sdk_svg__b",
    x1: 13.733,
    x2: -14.818,
    y1: 11.109,
    y2: 22.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "security-and-automation-sdk_svg__c",
    x1: 10.207,
    x2: -1.213,
    y1: 15.158,
    y2: 19.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "security-and-automation-sdk_svg__d",
    x1: 13.733,
    x2: -14.818,
    y1: 25.394,
    y2: 36.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "security-and-automation-sdk_svg__e",
    x1: 10.207,
    x2: -1.213,
    y1: 29.443,
    y2: 33.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "security-and-automation-sdk_svg__f",
    x1: 28.018,
    x2: -0.532,
    y1: 25.394,
    y2: 36.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "security-and-automation-sdk_svg__g",
    x1: 24.493,
    x2: 13.073,
    y1: 29.443,
    y2: 33.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "security-and-automation-sdk_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgSecurityAndAutomationSdk;